// ─────────────────────────────────────────────────────────────────────────────
//  Where the backend lives.
//
//  Two deployments, one client build:
//    • same-origin  — local dev and *.workers.dev serve the client from the
//                     Worker itself, so this is empty and every path is relative
//    • split        — the client is on GitHub Pages at osj.youniss.dev while the
//                     Durable Objects stay on Cloudflare, so the origin is baked
//                     in at build time via VITE_API_ORIGIN
//
//  Everything that talks to the server goes through here, so there is exactly
//  one place that knows which arrangement is in play.
// ─────────────────────────────────────────────────────────────────────────────

const CONFIGURED = (import.meta.env.VITE_API_ORIGIN ?? "").trim().replace(/\/+$/, "");

/** "" when same-origin, otherwise "https://osj-api.example.workers.dev". */
export const API_ORIGIN = CONFIGURED;

export function apiUrl(path: string): string {
  return `${API_ORIGIN}${path}`;
}

/** ws:// or wss:// to match however the API is reached. */
export function socketUrl(params: URLSearchParams): string {
  if (API_ORIGIN) {
    return `${API_ORIGIN.replace(/^http/, "ws")}/ws?${params}`;
  }
  const proto = window.location.protocol === "https:" ? "wss:" : "ws:";
  return `${proto}//${window.location.host}/ws?${params}`;
}
